import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openTextModalAction, closeModalAction } from '../../actions/modal';
import UserDetails from './components/Users/UserDetails';
import TeamUserDetails from './components/Teams/TeamUserDetails';
import IconToolTip from '../../common/IconToolTip';
import OverflowTip from '../../common/OverflowTip';
import TeamLinkedProjects from '../users/Modals/TeamLinkedProjects';
import Details from '../users/Details';

function TeamDetails(props) {
    const { onClose, customerId, openTab } = props;
    const { teamSideTabName } = useSelector((state) => state.customer);
    const dispatch = useDispatch();

    const closeModal = () => {
        dispatch(closeModalAction());
    };

    const removeUser = ({ agentId, teamId, agentName, teamName, customerId, tabName }) => {
        const customeMessage = `${agentName} removed ${teamName} from teamlist`;
        let payload = {
            customerId,
            teams: [teamId],
            agentId: agentId,
        };
        // dispatch(removeTeamsAgent({ data: payload, customeMessage, tabName, formName: 'removeUserFromTeamInUserDetails' }));
    };

    const handleRemove = ({ agentId, teamId, agentName, teamName, customerId, tabName }) => {
        let heading = 'Remove User';
        let text = `Do you want to remove ${agentName} from ${teamName}`;
        let buttons = [
            {
                showLoading: true,
                textOrComponent: 'Yes',
                type: 'red',
                buttonClass: 'hover:bg-scogoLightFillRed',
                onClick: () => {
                    removeUser({ agentId, teamId, agentName, teamName, customerId, tabName });
                },
            },
            {
                textOrComponent: 'No',
                type: 'blue',
                buttonClass: 'hover:bg-scogobgsky',
                onClick: () => {
                    closeModal();
                },
            },
        ];
        let closeOnBackdropClick = false;
        dispatch(openTextModalAction({ heading, text, buttons, closeOnBackdropClick, formName: 'removeUserFromTeamInUserDetails' }));
    };

    if (teamSideTabName === 'users')
        return <UserDetails customerId={customerId} onClose={onClose} handleRemove={handleRemove} headerComponent={headerComponent} />;
    else if (teamSideTabName === 'teams')
        return <TeamUserDetails customerId={customerId} onClose={onClose} handleRemove={handleRemove} headerComponent={headerComponent} />;
    else if (teamSideTabName === 'user_details')
        return (
            <Details
                onClose={onClose}
                openTab={openTab}
            />
        );
    else if (teamSideTabName === 'teamLinkedProjects') {
        return <TeamLinkedProjects onClose={onClose} headerComponent={headerComponent} />
    }
    return <></>;
}

export default TeamDetails;

export const headerComponent = ({ headName, onClick, hideCloseButton = false }) => {
    return (
        <div className='flex items-center justify-between px-3 py-2 w-full'>
            <div className='flex gap-2 items-center' style={{ maxWidth: '20vw' }}>
                <OverflowTip textClass='text-scogo15 2xl:text-font16 text-font12 font-rubik font-medium' someLongText={headName} />
            </div>
            {!hideCloseButton && <div className='ml-auto'>
                <div className=' h-6 cursor-pointer rounded-full flex items-center justify-center' onClick={onClick}>
                    <IconToolTip title='Close'>
                        <span className='material-icons text-scogoprimary font-medium align-middle 2xl:text-font16 text-font25 hover:text-scogoorange'>
                            highlight_off
                        </span>
                    </IconToolTip>
                </div>
            </div>}
        </div>
    );
};
